module.exports = __webpack_public_path__ + "img/image4@2x.b100adf0.png";